;(function (angular, _, moment) {
  'use strict'

  class UtilService {
    $q
    preferencesService
    invoiceTemplate
    quoteTemplate
    creditnoteTemplate
    orderTemplate
    isLoaded

    constructor (
      // Angular
      $q,
      // Libs
      // Managers
      // Services
      PreferencesService
      // Const
      // Resolved
    ) {
      this.$q = $q
      this.preferencesService = PreferencesService
      this.isLoaded = $q.all([
        PreferencesService.getInvoicePrefs(),
        PreferencesService.getQuotePrefs(),
        PreferencesService.getCreditNotePrefs(),
        PreferencesService.getOrderPrefs()
      ]).then(([invoice, quote, creditNote, order]) => {
        this.invoiceTemplate = invoice.numberFormat
        this.quoteTemplate = quote.numberFormat
        this.creditnoteTemplate = creditNote.numberFormat
        this.orderTemplate = order.numberFormat
      })
    }

    getInvoiceNumber (invoice, obj, template) {
      let result = '$n'
      if (template && template.length) {
        /* Get number template from object's numberFormat */
        result = template
      } else if (this[obj + 'Template']) {
        /* Get number template from prefs */
        result = this[obj + 'Template']
      }

      /** Replace $n by the invoice number and $n(x) by the number padded to x chars */
      result = result.replace(/\$n(?:\((\d*?)\))?/g, function (m, p1) {
        return _.padStart(invoice.number, p1, 0)
      })

      /** Replace $d(V) by the value found by the key 'V' in the invoice */
      result = result.replace(/\$v\((.*?)\)/g,
        function (m, p1) {
          return _.get(invoice, p1)
        })

      /** Replace $t by the invoice date $t(F) to format, F being a momentjs format string */
      result = result.replace(/\$t(?:\((.*?)\))?/g,
        function (m, p1) {
          p1 = p1 || 'MM-DD'
          return moment(invoice.date).format(p1)
        })

      return result
    }

    updateColumnList (columnList, customFields, defaultColumns) {
      let updated = []
      let cols = angular.copy(columnList)
      let defCols = angular.copy(defaultColumns)
      customFields.forEach(function (field) {
        if (!_.find(cols, { id: field.key })) {
          cols.push({ id: field.key, label: field.label, visible: false })
        }
      })

      _.each(defCols, function (c) {
        let copy = angular.copy(c)
        let exist = _.findIndex(cols, function (dc) {
          return dc.id === c.id || _.includes(c.alias, dc.id)
        })

        if (exist > -1) {
          copy.default = true
          copy.visible = cols[exist].visible
          copy.order = exist
        }
        updated.push(copy)
      })
      cols.forEach(function (column, index) {
        if (!_.find(updated, { id: column.id })) {
          column.order = index
          updated.push(column)
        }
      })
      updated = _.sortBy(updated, function (u) {
        return u.order
      })
      return updated
    }

    formatAddressLodgement (address) {
      if (!address) {
        return
      }
      const properties = [
        { label: 'Bat.', key: 'building' },
        { label: 'Eta.', key: 'floor' },
        { label: 'App.', key: 'apartment' },
        { label: 'Dig.', key: 'intercom' },
        { label: 'Esc.', key: 'stairs' },
        { label: 'Porte', key: 'door' }
      ]

      /**
       * For every property above, create the string, appending the correct label and value.
       * If we have more than 3 elements, add a <br> every 3 elements
       */

      var string = properties.reduce(function (result, prop, k) {
        if (address[prop.key]) {
          result += prop.label + ' ' +
            address[prop.key] +
            ((k % 3 === 2) ? '<br>' : ' - ')
        }
        return result
      }, '')
      return string
    }

    /**
     * Get legal notices
     * @return {Promise<string>}
     */
    getLegalNotices () {
      return this.preferencesService.getCompanyPrefs().then((companyPrefs) => {
        let legalNotices = _.get(companyPrefs, 'companyInfo.name')
        if (_.get(companyPrefs, 'companyInfo.siret')) {
          legalNotices += '<br>'
          legalNotices += 'N° SIRET ' + _.get(companyPrefs, 'companyInfo.siret')
        }
        if (_.get(companyPrefs, 'companyInfo.rcs')) {
          legalNotices += ' RCS ' + _.get(companyPrefs, 'companyInfo.rcs')
        }
        legalNotices += '<br>'
        legalNotices += _.get(companyPrefs, 'companyInfo.address.addressLine1')
        legalNotices += ' '
        legalNotices += _.get(companyPrefs, 'companyInfo.address.postalCode')
        legalNotices += ' '
        legalNotices += _.get(companyPrefs, 'companyInfo.address.city')
        legalNotices += '<br>'
        if (_.get(companyPrefs, 'companyInfo.phone') || _.get(companyPrefs, 'companyInfo.website')) {
          if (_.get(companyPrefs, 'companyInfo.phone')) {
            legalNotices += _.get(companyPrefs, 'companyInfo.phone')
          }
          if (_.get(companyPrefs, 'companyInfo.phone') && _.get(companyPrefs, 'companyInfo.website')) {
            legalNotices += ' - '
          }
          if (_.get(companyPrefs, 'companyInfo.website')) {
            legalNotices += _.get(companyPrefs, 'companyInfo.website')
          }
          legalNotices += '<br>'
        }
        if (_.get(companyPrefs, 'companyInfo.apeCode') || _.get(companyPrefs, 'companyInfo.vatIntracom')) {
          if (_.get(companyPrefs, 'companyInfo.apeCode')) {
            legalNotices += 'Code APE ' + _.get(companyPrefs, 'companyInfo.apeCode')
          }
          if (_.get(companyPrefs, 'companyInfo.apeCode') && _.get(companyPrefs, 'companyInfo.vatIntracom')) {
            legalNotices += ' - '
          }
          if (_.get(companyPrefs, 'companyInfo.vatIntracom')) {
            legalNotices += 'N° TVA Intracom. ' + _.get(companyPrefs, 'companyInfo.vatIntracom')
          }
          legalNotices += '<br>'
        }
        if (_.get(companyPrefs, 'companyInfo.iban')) {
          legalNotices += 'IBAN ' + _.get(companyPrefs, 'companyInfo.iban')
          legalNotices += ' '
        }
        if (_.get(companyPrefs, 'companyInfo.swift')) legalNotices += 'SWIFT ' + _.get(companyPrefs, 'companyInfo.swift')
        return legalNotices
      })
    }
  }

  UtilService.$inject = [
    // Angular
    '$q',
    // Libs
    // Managers
    // Services
    'PreferencesService'
    // Const
    // Resolved
  ]
  angular
    .module('kilo.common.services')
    .service('UtilService', UtilService)
})(window.angular, window._, window.moment)
